// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"q1-z","dimensionLabel":"r1-z","styleChooserControlWrapper":"s1-z","styleChooserControl":"t1-z","disabled":"u1-z","giftCard":"v1-z","styleChooserText":"w1-z"};